import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const searchUser = async (targetEmail) => {
  const response = await fetch(`${API_URL}/graph/search/${encodeURIComponent(targetEmail)}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Search failed');
  }

  return response.json();
};

// Send a trust request. type is 'work' or 'personal'.
// Response is deliberately generic — the requester never learns the outcome.
export const sendRequest = async (targetEmail, relationshipType) => {
  const response = await fetch(`${API_URL}/graph/request`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ targetEmail, relationshipType }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to send request');
  }

  return response.json();
};

// Incoming requests awaiting my answer.
export const getRequests = async () => {
  const response = await fetch(`${API_URL}/graph/requests`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch requests');
  }

  return response.json();
};

// Answer a request: answer is 'yes' or 'dont'. The requester is never told either way.
export const respondToRequest = async (requesterId, answer) => {
  const response = await fetch(`${API_URL}/graph/respond`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ requesterId, answer }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to record answer');
  }

  return response.json();
};

// 1-tap silent revoke + block. Severs the link and blocks re-requests.
// The other party is never notified.
export const removeContact = async (contactId) => {
  const response = await fetch(`${API_URL}/graph/remove`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ contactId }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to remove contact');
  }

  return response.json();
};

// My confirmed direct links only.
export const getNetwork = async () => {
  const response = await fetch(`${API_URL}/graph/network`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch network');
  }

  return response.json();
};
